import React from "react"

export default props => (
    <div className={`cell-start-${props.start} cell-end-${props.end}`}>
        {props.children}
    </div>
)
